import React from 'react';
import {PlayerDetail} from '@/features/players/api';
import {resolveAssetURL} from '@/services/api/client';

interface PlayerInfoProps { player: PlayerDetail }

const PlayerInfo: React.FC<PlayerInfoProps> = ({player}) => (
  <div className="flex min-w-0 items-center gap-4">
    <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-200 text-xl font-semibold text-gray-700 ring-2 ring-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:ring-gray-600">
      {player.photo_url
        ? <img src={resolveAssetURL(player.photo_url)} alt={`${player.name} headshot`} className="h-full w-full object-cover" />
        : player.name.charAt(0)}
    </div>
    <div className="min-w-0">
      <h1 className="break-words text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-3xl">{player.name}</h1>
      <p className="mt-1 break-words text-sm text-gray-600 dark:text-gray-400">
        {[player.position, player.team ?? 'Unassigned', `Age ${player.age}`, player.nationality].filter(Boolean).join(' / ')}
      </p>
    </div>
  </div>
);

export default PlayerInfo;
